import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export function YamlSourceBadge({ className = '' }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className={`bg-white/5 text-[#a1a1aa] border-white/10 cursor-default ${className}`}
          >
            Quelle: YAML-Import
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="bg-[#121214] border-white/10 text-white">
          Diese Daten werden aus YAML-Dateien importiert und sind nicht live editierbar.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

